import { useState } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { TextField, IconButton, InputAdornment } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import EventIcon from '@mui/icons-material/Event';

import classes from 'app/components/DataGrid/classes.module.scss';

const DatePicker2 = props => {
  const {
    InputProps
  } = props;

  const [open, setOpen] = useState(false);

  let datePickerProps = { ...props };

  // all props will be passed to MUI's DatePicker,
  // except for the value, which will be parsed by dayjs
  if (props.value) {
    datePickerProps.value = dayjs(props.value)
  } else {
    // MUI needs inputs to be controlled or uncontrolled
    // (the value is defined or undefined),
    // and throws an error if an input is switched after render.
    // since the datepicker is controlled (the other inputs are uncontrolled),
    // default the value to null.
    // passing undefined creates an uncontrolled input
    datePickerProps.value = null;
  }

  let clearIcon = null;
  if (props.showClearIcon && props.value) {
    clearIcon = (
      <IconButton className={classes.filterIconButton} onClick={props.onClear}>
        <CloseIcon className={classes.filterIcon} />
      </IconButton>
    );
  }

  const textField = params => (
    <TextField
      {...params}
      InputProps={{
        ...params.InputProps,
        ...InputProps,
        endAdornment: (
          <div>
            <InputAdornment position="end">
              {clearIcon}
              <IconButton className={classes.filterIconButton} onClick={() => setOpen(true)}>
                <EventIcon className={classes.filterIcon} />
              </IconButton>
            </InputAdornment>
          </div>
        )
      }}
    />
  );

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        {...datePickerProps}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        slots={{ textField }}
      />
    </LocalizationProvider>
  );
}

export default DatePicker2;
